<template>
  <div class="instructor-details">
    <div v-if="instructor" class="instructor-info">
      <div class="profile-section">
        <img :src="instructor.img_url || '/default-avatar.png'" alt="Instructor Profile" class="instructor-image">
        <div class="instructor-details">
          <h2>{{ instructor.first_name }} {{ instructor.last_name }}</h2>
          <div class="rating" v-if="instructor.rating">
            <span class="stars">
              <i class="fas fa-star"></i> {{ instructor.rating }}
            </span>
            <span class="reviews">({{ instructor.total_reviews || 0 }} reviews)</span>
          </div>
        </div>
      </div>
      <div class="bio" v-if="instructor.bio">
        <div v-html="instructor.bio"></div>
      </div>
    </div>
    <div v-else class="no-data">
      <p>Instructor details not available</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructorDetails',
  props: {
    instructor: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.instructor-details {
  padding: 1rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.profile-section {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.instructor-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 1rem;
}

.instructor-details h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
}

.rating {
  display: flex;
  align-items: center;
  color: #555;
}

.stars {
  color: #ffb400;
  margin-right: 0.5rem;
}

.bio {
  margin-top: 1rem;
  color: #555;
  line-height: 1.5;
}

.no-data {
  padding: 2rem;
  text-align: center;
  color: #888;
}
</style>
